// extracted by css-extract-rspack-plugin
export default {"bind-modal":"bind-modal-hGp3d6","bindModal":"bind-modal-hGp3d6"};